import { render } from "./external.vue?vue&type=template&id=5cfeb382"
import script from "./external.js?vue&type=script&lang=js&external"
export * from "./external.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__